<template>
    <div>
        <el-row>
            <el-col :span="24">
                <div class="buttonStyle" >
                        <el-button type="text" :class="$store.state.search.fastChoose === 'YESTERDAY' ? 'chooseActive':'choose'"  @click="onFastChoose('YESTERDAY')">昨日</el-button>
                        <el-button type="text" :class="$store.state.search.fastChoose === 'TODAY' ? 'chooseActive':'choose'"  @click="onFastChoose('TODAY')">今日</el-button>
                <!--        <el-button type="text" :class="$store.state.search.fastChoose === 'SZ' ? 'chooseActive':'choose'"  @click="onFastChoose('SZ')">上周</el-button>-->
                <!--        <el-button type="text" :class="$store.state.search.fastChoose === 'BZ' ? 'chooseActive':'choose'"  @click="onFastChoose('BZ')">本周</el-button>-->
                        <el-button type="text" :class="$store.state.search.fastChoose === 'LAST_TENCENT' ? 'chooseActive':'choose'"  @click="onFastChoose('LAST_TENCENT')">上旬</el-button>
                        <el-button type="text" :class="$store.state.search.fastChoose === 'THIS_TENCENT' ? 'chooseActive':'choose'"  @click="onFastChoose('THIS_TENCENT')">本旬</el-button>
                        <el-button type="text" :class="$store.state.search.fastChoose === 'LAST_MONTH' ? 'chooseActive':'choose'"  @click="onFastChoose('LAST_MONTH')">上月</el-button>
                        <el-button type="text" :class="$store.state.search.fastChoose === 'THIS_MONTH' ? 'chooseActive':'choose'"  @click="onFastChoose('THIS_MONTH')">本月</el-button>
                        <el-button type="text" :class="$store.state.search.fastChoose === 'LAST_SEASON' ? 'chooseActive':'choose'"  @click="onFastChoose('LAST_SEASON')">上季</el-button>
                        <el-button type="text" :class="$store.state.search.fastChoose === 'THIS_SEASON' ? 'chooseActive':'choose'"  @click="onFastChoose('THIS_SEASON')">本季</el-button>
                        <el-button type="text" :class="$store.state.search.fastChoose === 'LAST_YEAR' ? 'chooseActive':'choose'"  @click="onFastChoose('LAST_YEAR')">去年</el-button>
                        <el-button type="text" :class="$store.state.search.fastChoose === 'THIS_YEAR' ? 'chooseActive':'choose'"  @click="onFastChoose('THIS_YEAR')">本年</el-button>
                        <el-button type="text" :class="$store.state.search.fastChoose === 'ZDY' ? 'chooseActive':'choose'"  @click="onFastChoose('ZDY')" >自定义</el-button>
                </div>
                <div class="headStyle" v-show="dateShow">
                    <el-date-picker
                        v-if="timeMode"
                        v-model="$store.state.search.dateValue"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        size="small"
                    />
                    <el-date-picker
                        v-else
                        v-model="$store.state.search.dateValue"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        size="small"
                    />
                </div>
                <el-button
                    type="primary"
                    icon="el-icon-search"
                    size="mini"
                    style="margin-left: 20px"
                    class="queryButton "
                    @click="search">
                    搜索
                </el-button>
                <el-button
                    type="primary"
                    size="mini"
                    v-if="showExport"
                    class="queryButton queryButtonPadding qDcBtn"
                    @click="searchExport">
                    <el-image class="qDcImg" :src="require('@/assets/buttonGathers/query-dc.png')"></el-image>
                    &nbsp;导出
                </el-button>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: "search",
    data() {
        return {
            dateShow: false,
            // dateVal: ['2021-07-01','2021-07-15'],
            // fastChoose: 'JR',
            // jcdVal: null,
            showAll:false,
            jcxmVal:'',
            czVal:'',
            // czList:[],
        }
    },
    methods: {
        searchExport(){
            this.$emit('download');
        },
        onFastChoose(choosed) {
            this.$store.commit({
                type:'onFastChooseChange',
                value:choosed
            });
            if('ZDY' !== choosed){
                if(this.dateShow){
                this.dateShow = false;
                }
                this.$emit('query');
            }else{
                if(!this.dateShow){
                this.dateShow = true;
                }
            }
        },

        search(){
            // this.query(this.jcdVal,this.dateVal,this.fastChoose);
            if(this.dateShow && !this.$store.state.search.dateValue){
                this.$message.warning('请先选择时间再查询！');
                return;
            }
            this.$emit('query');
        },
    },
    props:['timeMode','showExport']
}
</script>

<style scoped>
    .chooseActive{
        color:#409EFF;
        margin-left: 2rem;
        float: left;
    }
    .choose{
        color:#909399;
        margin-left: 2rem;
        float: left;
    }
    .headStyle{
        margin-left: 1rem;
        float: left;
    }

    ::v-deep .buttonStyle .el-button--text {
        background: 0 0;
        padding-left: 0;
        padding-right: 0;
        padding-top: 6px;
    }
</style>
